var a="Non category page";export{a as NON_CATEGORY};
//# sourceMappingURL=common.js.map
